<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @addTab2="addTab2()" @addTab3="addTab3()" @removeTab="removeTab(item.name)" :minor='5'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import {mapState} from 'vuex'
import LoginLogLb from '../assembly/LoginLogLb.vue'
export default {
  components: {
    LoginLogLb
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '登录日志',
        name: '1',
        closable: false,
        ref: 'child',
        content: LoginLogLb
      }]
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    addTab2(id)
    {
      this.editableTabs.push(this.addobj2)
      this.editableTabsValue = this.addobj2.name
    },
    addTab3()
    {
      this.editableTabs.push(this.addobj3)
      this.editableTabsValue = this.addobj3.name
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/LoginLog.vue